angular.module('v3sWbtPlayerApp').filter('v3sSpaceless', function () {
    return function (input) {
        var result = "";
        if (!!input) {
            result = input.replace(/\s+/g, '-');
        }
        return result;
    }
});